var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.454,
    height: 7.369,
    viewBox: "0 0 12.454 7.369",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera",
    transform: "translate(0 -0.324)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12009",
    "data-name": "Path 12009",
    d: "M8.686,0H.934A.9.9,0,0,0,0,.859V6.51a.9.9,0,0,0,.934.859H8.686A.9.9,0,0,0,9.62,6.51V.859A.9.9,0,0,0,8.686,0Zm0,0",
    transform: "translate(0 0.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12010",
    "data-name": "Path 12010",
    d: "M328.906,36.273l3.211,1.753V31.981l-3.211,1.753Zm0,0",
    transform: "translate(-319.663 -30.985)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoicon);
export default __webpack_public_path__ + "static/media/videoicon.05b42e5a1874a946f95f7a540a69d3fd.svg";
export { ForwardRef as ReactComponent };